import { createPutEndpoint } from '@sonar-software/sonar-http';

export type PutUserProfilePictureRequest = {
	file: File;
};

export const putCurrentUserProfilePicture = createPutEndpoint<PutUserProfilePictureRequest>(
	'/api/v3/core/users/profile-picture',
	{
		requestTransform: (request) => ({
			fileOptions: {
				file: request.file,
				formName: 'profilePicture'
			}
		})
	}
);
